import React from "react";
import BaseComponent from "./baseComponent";
import ResetComponentPassword from "./ResetComponentPassword";
import Utils, { dispatchAction } from "../../utility";
import { connect } from "react-redux";
import { UserService } from "../../services";
import { history } from "../../managers/history";
import { cookiesConstants, eventConstants } from "../../constants";
import { sessionManager } from "../../managers/sessionManager";
import toast, { Toaster } from "react-hot-toast";
import CommonToasts from "../../common/components/commonToast";

class ChangePassword extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      oldPassword: "",
      password: "",
      confirmPassword: "",
      isPasswordVisible: false,
      isOldPasswordVisible: false,
      isConfirmPasswordVisible: false,
      passwordError:"",
      oldPasswordError:"",
      invalidPassword:""
    };
  }

  componentDidMount() {
    if (!this.props?.user?.IsLoggedIn) return history.push("/");
  }

  onChangeEvent = (event) => {
    this.setState({ [event.target.id]: event.target.value });
  };

  currentTogglePassword = (event) => {
    this.setState({ isPasswordVisible: !this.state.isPasswordVisible });
  };
  oldTogglePassword = (event) => {
    this.setState({ isOldPasswordVisible: !this.state.isOldPasswordVisible });
  };
  confirmTogglePassword = (event) => {
    this.setState({ isConfirmPasswordVisible: !this.state.isConfirmPasswordVisible });
  };
  logout = async () => {
    if (
      sessionManager.getDataFromCookies(cookiesConstants.REMEMBER_ME) ===
      "false"
    ) {
      sessionManager.removeDataFromCookies(cookiesConstants.EMAIL_ID);
      sessionManager.removeDataFromCookies(cookiesConstants.REMEMBER_ME);
      sessionManager.removeDataFromCookies(cookiesConstants.PASSWORD);
    }
    this.props.dispatchAction(eventConstants.LOGOUT_SUCCESS, {});
    sessionManager.removeDataFromCookies("accessToken");
    sessionManager.removeDataFromCookies(cookiesConstants.USER);
    sessionManager.removeDataFromCookies(cookiesConstants.IS_LOGIN);
    localStorage.clear();
    history.push("/");
  };

  onResetPasswordClicked = async (event) => {
    event.preventDefault();

    if (this.state.password !== this.state.confirmPassword) {
      // Utils.apiFailureToast(
      //   <div style={{whiteSpace: "nowrap", width: "310px"}}>
      //     {"Password & Confirm Password did not match"}
      //   </div>
      // );
      this.setState({passwordError: Utils.isPasswordValid(this.state.passwordError) ? "" : "Password & Confirm Password did not match"})
      return;
    }
    if (this.state.password === this.state.oldPassword) {
      this.setState({oldPasswordError: Utils.isPasswordValid(this.state.oldPasswordError) ? "" : "Old & New Password shouldn't same"});
      return;
    }

    let userDetails = localStorage.getItem("userDetails");
    userDetails = JSON.parse(userDetails);
    const requestData = {
      email: userDetails.userDetails.email,
      oldPassword: this.state.oldPassword,
      userId: userDetails.userDetails.sub,
      password: this.state.password,
    };

    const [error, response] = await Utils.parseResponse(
      UserService.changePassword(requestData)
    );


    if (response) {
      // Utils.apiSuccessToast("Password has been changed");
      CommonToasts.successfullySent("Password has been changed!!");

      this.logout();

    } else {
      // Utils.apiFailureToast("Invalid old password");
      this.setState({invalidPassword: Utils.isPasswordValid(this.state.invalidPassword) ? "" : "Invalid old password"});
      return;
    }

  };



  render() {
    return (
      <>
      <div>
          <Toaster />
        </div>
      <ResetComponentPassword
        state={this.state}
        onChangeEvent={this.onChangeEvent}
        currentTogglePassword={this.currentTogglePassword}
        oldTogglePassword={this.oldTogglePassword}
        confirmTogglePassword={this.confirmTogglePassword}
        onClose={this.props.onClose}
        onResetPasswordClicked={this.onResetPasswordClicked}
      />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return { user: state.user };
};
export default connect(mapStateToProps, { dispatchAction })(ChangePassword);
